<section>
    <div class="error404">
        <h1>Esta página no está disponible</h1>
        <h1 class="notfound">404</h1>
        <img src="../../../assets/IMG/errorimage.png" alt="" class="errorimage">
    </div>
</section>

